class LANG {
  static ARABIC = "arabic";
  static ENGLISH = "english";
  constructor() {}
}
export default LANG;
